import { Component } from '@angular/core';
import { Router, RouterOutlet } from '@angular/router';
import { TranslateDirective } from '../shared/translate.directive';
import { LoginComponent } from '../login/login.component';
import { LoginService } from '../shared/services/login.service';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { ErrorComponent } from '../shared/error/error.component';
import { EnglishToCyrillicDirective } from '../shared/cyrillic-input.directive';
import { LanguageProvider } from '../shared/language-provider';
import { SocialAuthService } from '@abacritt/angularx-social-login';

@Component({
  selector: 'app-user-profile',
  standalone: true,
  imports: [TranslateDirective, RouterOutlet, CommonModule, FormsModule, ErrorComponent, EnglishToCyrillicDirective],
  templateUrl: './user-profile.component.html',
  styleUrl: './user-profile.component.less'
})
export class UserProfileComponent {
  FB: any;
  constructor(private router: Router, private loginService: LoginService, private lang: LanguageProvider, private socialAuthService: SocialAuthService) {
  }

  t(key: string): string {
    return this.lang.translate(key);
  }

  errors = [];
  success: any;
  user: any;
  userModel: any;

  ngOnInit() {
    this.user = this.loginService.getUser();
    if (!!this.user) {
      this.userModel = this.user;
    }
  }

  updateUser() {
    this.errors = [];
    this.loginService.updateUser(this.userModel)
      .subscribe(res => {
        this.success = true;
        this.errors = [];
        this.loginService.setUser(this.userModel);
      }, errors => {
        this.success = false;
        this.errors = errors.error.errors;
      });
  }

  changePassword() {
    this.router.navigate(['/change-password']);
  }

  logout() {
    this.loginService.isLoggingOut = true;

    this.socialAuthService.signOut(true)
      .then(() => this.finalizeLogout())
      .catch(() => this.finalizeLogout());

    if (typeof this.FB !== 'undefined' && this.FB.logout) {
      try {
        this.FB.logout();
      } catch (e) {
        // Ignore if user wasn't actively logged into FB JS SDK session
      }
    }

    this.loginService.logout();
    this.router.navigateByUrl('/login');
  }
  private finalizeLogout() {
    this.loginService.logout();
    this.router.navigateByUrl('/login').then(() => {
      setTimeout(() => {
        this.loginService.isLoggingOut = false;
      }, 500);
    });
  }

  emailValid = true;
  emailChanged(e: any): void {
    this.userModel.Email = e;
    const re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    this.emailValid = re.test(String(this.userModel.Email).toLowerCase());
  }

  redirect() {
    this.router.navigate(['/app-list']);
  }
}
